import React from "react";
import { Row, Col } from "react-bootstrap";

interface ServicesDescriptionProps {
  children: React.ReactNode;
  id?: string;
  title?: string;
  colSize?: number;
  className?: string;
  link?: string;
  imageSrc?: string;
  imageClassName?: string;
}

const ServicesDescription: React.FC<ServicesDescriptionProps> = ({
  children,
  id,
  title,
  colSize,
  className,
  imageSrc,
  link,
  imageClassName,
}: ServicesDescriptionProps) => {
  return (
    <Row id={id || null} className={`service-description-content ${className || ""}`}>
      {imageSrc ? 
        <Col sm={12} md={colSize ? 12 - colSize : "auto"} className="service-description-img-col">
          {
            link ?
              <a href={link}>
                <img className={imageClassName || "service-description-img"} src={imageSrc} />
              </a>
              : <img className={imageClassName || "service-description-img"} src={imageSrc} />
          }
        </Col> 
      : <></>}
      <Col sm={12} md={colSize || (imageSrc ? 4 : 10)} className="text-left d-flex flex-column">
        {title && (
          link ?
          <a href={link}>
            <h3 className="service-description-title gotham-medium">{title}</h3>
          </a>
          : <h3 className="service-description-title gotham-medium">{title}</h3>)}
        {children}
      </Col>
    </Row>
  );
};

export default ServicesDescription;